import { render, staticRenderFns } from "./SuppliersImporter.vue?vue&type=template&id=6b1a60fa&scoped=true&"
import script from "./SuppliersImporter.vue?vue&type=script&lang=js&"
export * from "./SuppliersImporter.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersImporter.vue?vue&type=style&index=0&id=6b1a60fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a60fa",
  null
  
)

export default component.exports